// eslint-disable-next-line @typescript-eslint/ban-types
export const isObjectNull = (object: object | undefined): boolean => {
  if (object === undefined || object === null) {
    return true
  }
  return Object.values(object).every((x) => x === null)
}
